import { IDeleteEntradaPUseCase } from "../../../presentation/useCases/delete/delete_entrada_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class DeleteEntradaPUseCase implements IDeleteEntradaPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async deleteEntradaP(IdEntradaProduto: number): Promise<void> {
    
    await this.repository.deleteEntradaP(IdEntradaProduto);
  }
}
